module.exports = __webpack_public_path__ + "static/img/74039A_C_04_20170813_fit.4417a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/74039A_C_04_20170813_fit.png
// module id = SWWL
// module chunks = 0